module.exports = __webpack_public_path__ + "img/level2.e0832916.svg";